<div class="app-container">
  <lh-header class="app-header-container"></lh-header>
  <div class="app-main-container">
    <div class="app-main-columns">
      <div class="app-main-sidebar-column scrollbar-invisible">
        <thehubz-left-menu></thehubz-left-menu>
      </div>
      <div class="application-feature-modules flex-1">
        <div class="app-main-wrapper h-full">
          <sp-page-title [ngClass]="{ hidden: !hasHeadline }"></sp-page-title>

          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
  <div class="app-footer-container">
    <div class="footer-contant">
      <lh-footer></lh-footer>
      <sp-footer></sp-footer>
    </div>
  </div>
</div>
